// TEMPORARY MIGRATION CODE — remove with the rest of lib/migration/. See ./AGENTS.md.
//
// Maps the legacy ClientConsole invite hash (`#/invite?token=…`) onto web's
// public path route `/invite?token=…`. No org prefix (unlike `legacyRouteMap`):
// the invite flow is unauthenticated and org-less. Pure, so it unit-tests in
// node. Returns `null` for any hash that isn't the invite link.
export const mapLegacyInviteHash = (hash: string): string | null => {
  if (!hash.startsWith("#/")) return null
  const stripped = hash.slice(1)
  const queryStart = stripped.indexOf("?")
  const path = queryStart === -1 ? stripped : stripped.slice(0, queryStart)
  // Exact match — don't catch "/invitee" or other "/invite…" segments.
  if (path !== "/invite") return null
  const query = queryStart === -1 ? "" : stripped.slice(queryStart)
  return `/invite${query}`
}
